import { IRegEdSubmissionView } from '@Queries/RegEdCompliance';
import * as Api from '@ViewModels';
import { LocationDescriptorObject } from 'history';
import { ILocationState } from '../../../models';
import { getSocialMediaPlainTextContentFromRawRichContent } from '../../../models/UiUtils';

interface IRegEdSocialReviseModel {
	type: 'Template';
	postContent: string;
	postTargets: Api.IPostTarget[];
	regEdRevise: {
		revisesApprovalRequestId: string;
		format: string;
		answers: Record<string, unknown>;
	};
}

/**
 * A rejection cancels the post server-side, so a revision is always a fresh post carrying the prior
 * approval-request id — never an edit of the cancelled one.
 *
 * Returns the location rather than navigating: a caller already inside the fullscreen modal pushes it
 * on `useHistory()`, while one in the app router must push it on `fullscreenModal.history`.
 */
export const buildRegEdSocialReviseLocation = (
	// Structural rather than the view-model type: the post editor holds a
	// `SocialMediaPostReportViewModel` on some routes, which carries the targets but no content.
	post: {
		content?: Api.IRawRichTextContentState;
		designatedTargets?: Api.IPostTarget[];
		targets?: Api.IPostTarget[];
	},
	submission: IRegEdSubmissionView
): LocationDescriptorObject => {
	const state: ILocationState<never, IRegEdSocialReviseModel> = {
		model: {
			type: 'Template',
			postContent: getSocialMediaPlainTextContentFromRawRichContent(post.content),
			postTargets: post.designatedTargets?.length ? post.designatedTargets : post.targets,
			regEdRevise: {
				revisesApprovalRequestId: submission.approvalRequestId,
				format: submission.metadata?.format,
				answers: submission.metadata?.answers,
			},
		},
	};
	return { pathname: '/social-media/post/create/from-reged-revision', state };
};
